import { render, staticRenderFns } from "./InstantMedicationTable.vue?vue&type=template&id=7fccd7b7&scoped=true"
import script from "./InstantMedicationTable.vue?vue&type=script&lang=js"
export * from "./InstantMedicationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fccd7b7",
  null
  
)

export default component.exports